import { render } from "./ping.vue?vue&type=template&id=39dab80e"
import script from "./ping.vue?vue&type=script&lang=js"
export * from "./ping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__